module.exports = __webpack_public_path__ + "media/bg-video.75eb37cf.mp4";